import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {FilterPipe} from "./service/filterPipe";
import {FileUploadModule} from "ng2-file-upload";
import {Safe} from "./service/keep-html.pipe";
import { FooterComponent, NavbarComponent, } from './layouts';
import { TransformMoneyPipe } from "./pipe/transformMoney.pipe";
import { TransformCustomDatePipe } from "./pipe/transformCustomDate.pipe";
import { TransformPhonePipe } from "./pipe/transformPhone.pipe";
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';
import { PublicViewImageComponent } from "./components/public-view-image/public-view-image";
import { ErrorTextComponent } from "./components/error-text/error-text.component";
import { NewOTPComponent } from "./components/otp/otp.component";
import { FileSizePipe } from "./service/filesize.service";
import { AutoCompleteComponent } from "./components/auto-complete/auto-complete.component";
import { PagingComponent } from "./components/paging/paging.component";
import { InputNoteComponent } from "./components/input-note/input-note.component";
import { InputNumberComponent } from "./components/input-number/input-number";
import { FilterStartEndDateComponent } from "./components/filter-start-end-date/filter-start-end-date";
import { ColorPickerModule } from 'ngx-color-picker';
import { PickColor } from "./components/pick-color/pick-color.component";
import { InputDateComponent } from "./components/input-date/input-date";
import { SearchAgencyComponent } from "../business-operations/components/search-agency/search-agency.component";
import { InputDatePickerAndTimeComponent } from "./components/input-datepicker-and-time/input-datepicker-and-time";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    FileUploadModule,
    HttpClientModule,
    NgbModalModule,
    NgbTooltipModule,
    ColorPickerModule
  ],
  declarations: [
    FilterPipe,
    Safe,
    FooterComponent,
    NavbarComponent,
    TransformCustomDatePipe,
    TransformMoneyPipe,
    TransformPhonePipe, FileSizePipe,
    PagingComponent,
    DropdownSearchComponent, AutoCompleteComponent,
    PublicViewImageComponent,
    ErrorTextComponent,
    NewOTPComponent,
    InputNoteComponent, InputNumberComponent,
    FilterStartEndDateComponent,
    SearchAgencyComponent,
    PickColor, InputDateComponent,
    InputDatePickerAndTimeComponent
  ],
  exports: [
    HttpClientModule,
    NgbModalModule,
    NgbTooltipModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    FooterComponent, NavbarComponent,
    TransformCustomDatePipe, TransformMoneyPipe, FileSizePipe, Safe,  FilterPipe,
    PagingComponent, DropdownSearchComponent, AutoCompleteComponent, NewOTPComponent,
    ErrorTextComponent, InputNoteComponent, InputNumberComponent,
    FilterStartEndDateComponent,
    SearchAgencyComponent,
    PickColor, InputDateComponent,
    InputDatePickerAndTimeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule{ }
